export enum ScormRequestResult {
  CREATED = 'scorm.created',
  FAILED = 'scorm.failed',
}

export type ScormWebhookRequest = {
  type: ScormRequestResult;
  createdAt: number;
  request: {
    type: string;
  };
  data: {
    downloadURL?: string;
    reason?: string; // error message for internal logging, email for user should always have the same text
    code?: string; // custom error code from Scorm API
  };
};
